import { Link } from "react-router-dom";
import { ArrowLeft, Phone } from "lucide-react";
import { AGENCY } from "@/data/content";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-brand-cream">
      <header className="bg-brand-green text-brand-cream">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 py-6 flex items-center justify-between">
          <Link to="/" data-testid="legal-back-link"
            className="flex items-center gap-2 text-sm text-brand-cream/80 hover:text-brand-cream transition-colors">
            <ArrowLeft className="h-4 w-4" /> Back to site
          </Link>
          <a href={AGENCY.phoneHref} className="flex items-center gap-2 text-sm text-brand-sand">
            <Phone className="h-4 w-4" /> {AGENCY.phone}
          </a>
        </div>
        <div className="mx-auto max-w-3xl px-5 sm:px-8 pb-12 pt-4">
          <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-brand-sand">Legal</span>
          <h1 className="font-serif text-4xl sm:text-5xl mt-3">{title}</h1>
          <p className="mt-3 text-brand-cream/60 text-sm">Last updated: {updated}</p>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 sm:px-8 py-14">
        <article className="legal-body space-y-6 text-brand-moss leading-relaxed">
          {children}
        </article>
      </main>

      <footer className="border-t border-brand-line">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-brand-moss">
          <span>© {new Date().getFullYear()} {AGENCY.name} · {AGENCY.legalName} · anicobr.com</span>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-brand-green">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-brand-green">Terms of Service</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export function H2({ children }) {
  return <h2 className="font-serif text-2xl sm:text-3xl text-brand-ink pt-4">{children}</h2>;
}
export function P({ children }) {
  return <p className="text-[15px]">{children}</p>;
}
export function UL({ children }) {
  return <ul className="list-disc pl-5 space-y-1.5 text-[15px]">{children}</ul>;
}
